import { Component, OnInit, OnDestroy, NgZone, EventEmitter } from '@angular/core';

import { Subscription } from 'rxjs';

import {
    AuthorizationService
} from './../../../shared/index';

@Component({
    selector: 'device-index',
    templateUrl: './device-index.html',
    standalone: false
})

export class DeviceIndexComponent implements OnInit, OnDestroy {
    ngOnInit(): void {
    }

    ngOnDestroy(): void {
    }
}
